module.exports = __webpack_public_path__ + "static/media/mocktext-img.56e35737.png";